import bgmyprofile from "@/assets/Image2.png";
const AllEventHero = () => {
  return (
    <section className="w-full pt-24 md:pt-[120px] mx-auto">
      <div className="flex flex-col  relative">
        <img
          src={bgmyprofile}
          alt=""
          width={800}
          height={800}
          className="w-full h-56 object-cover"
        />
        <div
          id="all-events"
          className="absolute rounded-lg md:rounded-none px-6 py-6  md:px-0 md:py-0 md:w-[30%] ml-3 md:ml-0 flex top-10 left-24 md:top-0 md:left-0 bg-black bg-opacity-60 md:h-full "
        >
          <h1 className="text-4xl  md:mt-32 md:ml-36 font-semibold opacity-90 text-white">
            All Events
          </h1>
        </div>
      </div>
      <div className="max-w-6xl mb-20 px-4 md:px-0 mx-auto"> </div>
    </section>
  );
};

export default AllEventHero;
